import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { Box, InlineAlert, Input, Text } from '@cmpsr/components';
import { UseFormReturn } from 'react-hook-form';

type EarlyAccessFormType = {
  inviteCode: string;
};

export type EarlyAccessFormComponentProps = {
  form: UseFormReturn<EarlyAccessFormType>;
};

export default function EarlyAccessForm({ form }: EarlyAccessFormComponentProps) {
  return (
    <Box>
      <FormControl id="invite-code" isInvalid={!!form.formState.errors.inviteCode}>
        <FormLabel htmlFor="inviteCode">
          <Text variant="text-body-floating-label-regular" textTransform="uppercase" mb="spacer-2">
            invite code
          </Text>
        </FormLabel>
        <Input
          id="inviteCode"
          aria-label="Invite Code"
          variant="outline"
          size="l"
          placeholder={form.formState.errors.inviteCode ? '' : 'CODE123456'}
          {...form.register('inviteCode', {
            required: true,
          })}
          isInvalid={!!form.formState.errors.inviteCode}
        />
        {form.formState.errors.inviteCode?.message && (
          <FormErrorMessage>
            <InlineAlert status="error" mt="spacer-2">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.inviteCode.message}</InlineAlert.Message>
            </InlineAlert>
          </FormErrorMessage>
        )}
      </FormControl>
    </Box>
  );
}
